import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { update_downtime_reason } from "../../../api";
// import edit_icon from "../../../assets/images/icons/controls/edit_icon.png";
import { Tooltip } from "react-tooltip";
import { Edit2 } from "react-feather";
import DatePicker from "react-datepicker";

function minutesToDate(duration) {
  let baseDate = new Date();
  baseDate.setHours(0, 0, 0, 0);

  if (duration === 1440) {
    // Return next day 00:00 but mark as 24:00 for display
    return {
      date: new Date(baseDate.getTime() + duration * 60000),
      display: "24:00",
    };
  }
  return new Date(baseDate.getTime() + duration * 60000);
}

const schema = yup.object().shape({
    downtimeReasonName: yup.string().required("Downtime reason is required"),
    colorCode: yup.string().required("Color is required"),
    category: yup.string().nullable(),
});

function EditDowntimeReason({ data, fetchReasons }) {
    const [visible, setVisible] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
        control,
        setValue,
        clearErrors,
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            downtimeReasonName: data.reason,
            colorCode: data.color_code,
            category: data?.category || "",
            duration: minutesToDate(data.duration),
        },
    });

    const onSubmit = async (form) => {
        try {
            let totalMinutes = 0;
            const val = data?.duration;
            if (val instanceof Date && !isNaN(val) && val !== null) {
                const hours = val.getHours();
                const minutes = val.getMinutes();
                totalMinutes += hours * 60 + minutes;
            }
            const payload = {
                uuid: data.uuid, // IMPORTANT for update
                downtime_reason: form.downtimeReasonName,
                color_code: form.colorCode,
                category: form.category || null,
                duration: totalMinutes,
            };

            await update_downtime_reason(payload);

            toast.success("Downtime reason updated successfully");
            setVisible(false);
            fetchReasons();

        } catch (error) {
            console.log("error", error);

            toast.error(
                error?.response?.data?.message || "Failed to update downtime reason",
                { autoClose: 2000 }
            );
        }
    };


    return (
        <React.Fragment>
            <Tooltip id={"edit-tooltip"} place="top" />
            <div
                data-tooltip-id={"edit-tooltip"}
                data-tooltip-content={"Edit downtime reason"}
                className="editIcon me-2">
                <Edit2
                    color="#FFFFFF"
                    size={18}
                    className="cursor-pointer"
                    onClick={() => {
                        setVisible(true);
                        reset();
                    }}
                />
            </div>
            <Modal show={visible} onHide={() => setVisible(false)} size={"md"}>
                <Modal.Header
                    style={{ background: "#2A3643", color: "white" }}
                    closeButton
                >
                    <Modal.Title>{"Update Downtime Reason"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form action="">
                        <div className="form-group row mt-2">
                            <label
                                style={{ fontSize: "14px" }}
                                className="col-form-label col-md-12 roboto-bold"
                            >
                                {"Category"}
                            </label>
                            <div className="col-md-12">
                                <select
                                    className={
                                        errors.category ? "form-control is-invalid" : "form-control"
                                    }
                                    id="category"
                                    name="category"
                                    defaultValue={data?.category || ""}
                                    {...register("category")}
                                >
                                    <option value="">Select category</option>
                                    <option value="Loading">Loading</option>
                                    <option value="Downtime">Downtime</option>
                                </select>
                                <span className="text-danger err-msg">
                                    {errors.category?.message}
                                </span>
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label
                                style={{ fontSize: "14px" }}
                                className="col-form-label col-md-12 roboto-bold"
                            >
                                {"Reason Name"}
                                <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className={
                                        errors.downtimeReasonName
                                            ? "form-control  is-invalid"
                                            : "form-control "
                                    }
                                    id="downtimeReasonName"
                                    name="downtimeReasonName"
                                    placeholder="Enter downtime reason"
                                    defaultValue={data?.downtime_reason}
                                    {...register("downtimeReasonName")}
                                />
                                <span className="text-danger err-msg">
                                    {errors.downtimeReasonName?.message}
                                </span>
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label
                                style={{ fontSize: "14px" }}
                                className="col-form-label col-md-12 roboto-bold"
                            >
                                {"Duration"}
                                <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-12">
                                <Controller
                                    control={control}
                                    name={`duration`}
                                    render={({ field: { onChange, value } }) => (
                                        <DatePicker
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={10}
                                            timeCaption="Time"
                                            className="form-control mt-2"
                                            placeholderText="HH:MM"
                                            selected={value}
                                            onChange={(selectedTime) => {
                                                clearErrors(`duration`);
                                                onChange(selectedTime);
                                            }}
                                            isClearable // ✅ allow user to clear the time
                                            onClear={() => {
                                                setValue(`duration`, null);
                                                clearErrors(`duration`);
                                            }}
                                            dateFormat="HH:mm"
                                            timeFormat="HH:mm"
                                            autoComplete="off"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-2">
                            <label
                                style={{ fontSize: "14px" }}
                                className="col-form-label col-md-12 roboto-bold"
                            >
                                {"Color"}
                                <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-12 d-flex align-items-center gap-2">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    {...register("colorCode")}
                                />
                                <span
                                    className="px-3 py-1 rounded-pill text-white"
                                    style={{
                                        background: watch("colorCode") || "#999"
                                    }}
                                >
                                    Preview
                                </span>
                            </div>
                            <span className="text-danger err-msg">
                                {errors.colorCode?.message}
                            </span>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={handleSubmit(onSubmit)}
                        className="f-16 btn btn-yellow "
                    >
                        {"Save"}
                    </button>
                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default EditDowntimeReason
